import React from "react";
import { useTranslation } from "react-i18next";
import { StatusBadge, type StatusTone } from "@/shared/ui/kit/StatusBadge";
import type { TenantStatus } from "@/entities/tenant/model/types";

const STATUS_TONE: Record<TenantStatus, StatusTone> = {
    PROVISIONING: "info",
    ACTIVE: "success",
    SUSPENDED: "danger",
    CANCELLED: "neutral",
    FAILED: "danger",
};

export default function TenantStatusBadge({ status }: { status: TenantStatus }) {
    const { t } = useTranslation("common");
    return <StatusBadge tone={STATUS_TONE[status]}>{t(`platform.tenants.status.${status}`)}</StatusBadge>;
}
